import { AutoForm } from "@mguidetti/stimulus-components"

export default class extends AutoForm {
  // Overwrite addQueryString to use Turbo's history API
  addQueryString(event) {
    const params = new URLSearchParams(new FormData(event.target))
    const url = new URL(window.location)
    url.search = params.toString()

    Turbo.navigator.history.replace(url)
  }

  clearInput(event) {
    const input = event.params.clearInput 
      ? this.element.querySelector(`input[name="${event.params.clearInput}"]`)
      : event.target

    if (!input) {
      console.warn(`Input not found.`)
    } else {
      input.value = ""
    }
  }

  submit (event) {
    if (event.target.form) {
      event.target.form.requestSubmit() 
    } else {
      this.formTarget.requestSubmit()
    }

    this.dispatch('submitted')
  }
}
